import {
  DrivetrainFaultLevel,
  DrivetrainSchematicEntry,
} from '../../../core/models/asset-type.models';

export interface DrivetrainFaultAdapted {
  id?: number;
  name: string;
  level: DrivetrainFaultLevel;
}

export interface DrivetrainBlockAdapted {
  id?: number;
  label: string;
  subtitle?: string;
  active: boolean;
  badge: string;
  faults: DrivetrainFaultAdapted[];
}

export interface DrivetrainLegendItemAdapted {
  id?: number;
  level: DrivetrainFaultLevel;
  description: string;
}

export interface DrivetrainSchematicAdapted {
  title: string;
  intro: string;
  callout: string;
  blocks: DrivetrainBlockAdapted[];
  legend: DrivetrainLegendItemAdapted[];
}

export function adaptDrivetrainSchematicBlock(
  entry: Record<string, unknown>,
  _baseUrl: string,
): Record<string, unknown> {
  const data = entry as unknown as DrivetrainSchematicEntry;
  const rawBlocks = Array.isArray(data.blocks) ? data.blocks : [];
  const blocks: DrivetrainBlockAdapted[] = rawBlocks.map((b, i) => ({
    id: b.id,
    label: b.label,
    subtitle: b.subtitle,
    active: Boolean(b.active),
    badge: b.active ? 'ESA' : String(i + 1).padStart(2, '0'),
    faults: Array.isArray(b.faults) ? b.faults : [],
  }));
  const legend: DrivetrainLegendItemAdapted[] = Array.isArray(data.legend)
    ? data.legend
    : [];
  return {
    data: {
      title: data.title ?? '',
      intro: data.intro ?? '',
      callout: data.callout ?? '',
      legend,
      blocks,
    },
  };
}
